import React from 'react';
import { Check, ArrowUpRight } from 'lucide-react';
import { services } from '../data/site';
export function Services() {
  return <section id="services" className="bg-[#FFFDF6] py-20 lg:py-28" data-id="element-176" data-mp="1hw5pr6axgote">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-177" data-mp="1dt9e5zjt1syy">
        <div className="max-w-2xl" data-id="element-178" data-mp="1dvvkxwyvg4g4">
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#0B1B2B]/50" data-id="element-179" data-mp="18vr05uqxknk3">
            Services
          </p>
          <h2 className="mt-3 text-4xl font-black leading-[1.02] tracking-tight text-[#0B1B2B] sm:text-5xl" data-id="element-180" data-mp="13xfpxiwq4b1c">
            Everything on the outside of your building, handled.
          </h2>
          <p className="mt-4 text-lg text-[#0B1B2B]/70" data-id="element-181" data-mp="u6uycffgw6rx">
            One crew, one invoice, one standard. Bundle any two services and save 10%.
          </p>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-182" data-mp="l5wt5ttalt7r">
          {services.map((service, i) => <li key={service.id} className={`group flex flex-col overflow-hidden rounded-[1.75rem] border-4 border-[#0B1B2B] transition hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#0B1B2B] ${i % 3 === 0 ? 'bg-[#EAF7FF]' : 'bg-white'}`} data-id="element-183" data-mp="g60kvidkbfme" data-mpi={i}>
              {service.image && <div className="h-48 w-full overflow-hidden border-b-4 border-[#0B1B2B]" data-id="element-184" data-mp="2x9ore0vkl07q">
                  <img src={service.image} alt="" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" loading="lazy" data-id="element-185" data-mp="32b4avoi3myo0" />
                </div>}
              <div className="flex flex-1 flex-col p-7" data-id="element-186" data-mp="3g1rbxnbc10n9">
                <div className="flex items-start justify-between gap-4" data-id="element-187" data-mp="3l0ui5b31tcwt">
                  <h3 className="text-2xl font-black tracking-tight text-[#0B1B2B]" data-id="element-188" data-mp="3l36zbm0zfj8t">
                    {service.title}
                  </h3>
                  <span className="whitespace-nowrap rounded-full border-2 border-[#0B1B2B] bg-[#FFD84D] px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-[#0B1B2B]" data-id="element-189" data-mp="29n8igvzkbsx1">
                    {service.price}
                  </span>
                </div>
                <p className="mt-3 text-base leading-relaxed text-[#0B1B2B]/70" data-id="element-190" data-mp="1grsltooqs8b1">
                  {service.blurb}
                </p>
                <ul className="mt-5 space-y-2" data-id="element-191" data-mp="1bth832vbtdnj">
                  {service.bullets.map(bullet => <li key={bullet} className="flex items-center gap-2 text-sm font-bold text-[#0B1B2B]" data-id="element-192" data-mp="16unvrdrrzsoy">
                      <Check className="h-4 w-4 shrink-0 text-[#16A34A]" aria-hidden="true" data-id="element-193" data-mp="xsmywi0gf8nt" />
                      {bullet}
                    </li>)}
                </ul>
                <a href="#quote" className="mt-6 inline-flex items-center gap-1.5 self-start text-sm font-extrabold text-[#0B1B2B] underline decoration-[#FFD84D] decoration-4 underline-offset-4" data-id="element-194" data-mp="2s6xncpd500t2">
                  Quote this service
                  <ArrowUpRight className="h-4 w-4" aria-hidden="true" data-id="element-195" data-mp="2upj8u5spnys4" />
                </a>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}